import { render, staticRenderFns } from "./tacticsRule.vue?vue&type=template&id=1d122f22&scoped=true"
import script from "./tacticsRule.vue?vue&type=script&lang=js"
export * from "./tacticsRule.vue?vue&type=script&lang=js"
import style0 from "./tacticsRule.vue?vue&type=style&index=0&id=1d122f22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d122f22",
  null
  
)

export default component.exports